<template>
  <div>
    <div style="position: absolute; top: 0; width: 100%; z-index: 2">
      <v-slide-y-transition>
        <v-toolbar :color="dark? 'grey darken-3':'white'" class="elevation-2" flat v-if="offsetTop > 150">
          <v-flex align-center layout row>
            <!--<div style="width: 160px">-->
            <!--<v-select-->
            <!--:disabled="filterDisabled"-->
            <!--:items="searchFilterItems"-->
            <!--:prepend-icon="searchFilter.action"-->
            <!--class="pr-2"-->
            <!--return-object-->
            <!--single-line-->
            <!--v-model="searchFilter"-->
            <!--&gt;</v-select>-->
            <!--</div>-->
            <v-text-field
              @keyup.enter="$refs.lDataTable.refresh(true)"
              autofocus
              placeholder="搜索车辆，需要输入完整车牌"
              single-line
              v-if="searchFilter.value === 'plate'"
              v-model="search"
            ></v-text-field>
            <v-text-field
              @keyup.enter="$refs.lDataTable.refresh(true)"
              autofocus
              placeholder="搜索车辆，需要输入完整车牌"
              single-line
              v-else
              v-model="searchFormatted"
            ></v-text-field>
          </v-flex>
          <v-toolbar-items>
            <v-tooltip bottom>
              <v-btn @click="$refs.lDataTable.refresh(true)" class="mr-0 subheading" color="primary" flat
                     slot="activator">
                搜索
              </v-btn>
              <span>点击搜索</span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
      </v-slide-y-transition>
    </div>
    <l-fixed-window :offset-top.sync="offsetTop">
      <v-container fluid grid-list-lg>
        <v-layout class="mb-3" justify-center row>
          <v-flex lg8 md10 xs12>
            <v-toolbar :color="dark? 'grey darken-3':'white'" class="elevation-1 pr-0" flat>
              <v-flex align-center layout row>
                <!--<div style="width: 160px">-->
                <!--<v-select-->
                <!--:di`sabled="filterDisabled"-->
                <!--:items="searchFilterItems"-->
                <!--:prepend-icon="searchFilter.action"-->
                <!--class="pr-2"-->
                <!--return-object-->
                <!--single-line-->
                <!--v-model="searchFilter"-->
                <!--&gt;</v-select>-->
                <!--</div>-->
                <v-text-field
                  @keyup.enter="$refs.lDataTable.refresh(true)"
                  autofocus
                  placeholder="搜索车辆，需要输入完整车牌"
                  single-line
                  v-if="searchFilter.value === 'plate'"
                  v-model="search"
                ></v-text-field>
                <v-text-field
                  @keyup.enter="$refs.lDataTable.refresh(true)"
                  autofocus
                  placeholder="搜索车辆，需要输入完整车牌"
                  single-line
                  v-else
                  v-model="searchFormatted"
                ></v-text-field>
                <!--<input v-model="searchFormatted"/>-->
              </v-flex>
              <!--<v-tooltip bottom>-->
              <!--<v-btn @click="togglePrecious()" slot="activator" icon>-->
              <!--<v-icon :color="precious?'primary':''">-->
              <!--{{precious?'vertical_align_center':'format_line_spacing'}}-->
              <!--</v-icon>-->
              <!--</v-btn>-->
              <!--<span>{{precious?'精确搜索':'模糊搜索'}}</span>-->
              <!--</v-tooltip>-->
              <!--<v-tooltip bottom>-->
              <!--<v-btn slot="activator" v-model="filter" icon @click="filter = !filter">-->
              <!--<v-icon>filter_list</v-icon>-->
              <!--</v-btn>-->
              <!--<span>筛选</span>-->
              <!--</v-tooltip>-->
              <v-toolbar-items>
                <v-tooltip bottom>
                  <v-btn @click="$refs.lDataTable.refresh(true)" class="mr-0 subheading" color="primary" flat
                         slot="activator">
                    搜索
                  </v-btn>
                  <span>点击搜索</span>
                </v-tooltip>
              </v-toolbar-items>
            </v-toolbar>
          </v-flex>
        </v-layout>
        <!--<h1>{{offsetTop}}</h1>-->
        <v-layout justify-center row>
          <v-flex xs12>
            <v-expand-transition>
              <div :key="'filter'" v-if="filter">
                <!--<v-divider></v-divider>-->
                <v-card class="mb-4">
                  <v-container class="py-3" fluid grid-list-md>
                    <v-form ref="filterForm">
                      <v-layout row wrap>
                        <v-flex xs4>
                          <v-text-field
                            label="test"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            label="test"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            label="test"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex>
                          <v-btn class="mx-0 my-0" color="primary" small>筛选</v-btn>
                          <v-btn small>重置</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card>
                <!--<v-divider></v-divider>-->
              </div>
            </v-expand-transition>
            <div :key="'result'">
              <l-data-table
                :get-data-func="getVehicles"
                :headers="headers"
                @click:row="goDetails($event.item, $event.index)"
                auto-actions
                clickable
                hide-title
                init-sort-by="plate"
                ref="lDataTable"
                v-show="vehicleAmount"
              >
              </l-data-table>
              <v-flex class="subheading text-xs-center" v-show="!vehicleAmount">
                <div v-if="loading">数据加载中...</div>
                <!--<div v-else-if="errorData.error">-->
                <!--<span>数据加载出错: {{errorData.message}}, code: {{errorData.code}}</span>-->
                <!--</div>-->
                <div class="grey--text subheading" v-else-if="search && hadSearched">没有车辆记录</div>
                <div class="grey--text subheading" v-else-if="search">点击搜索按钮开始搜索</div>
                <div class="grey--text subheading" v-else>输入以搜索</div>
              </v-flex>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </l-fixed-window>
  </div>
</template>

<script>
export default {
  name: 'SearchVehicle',
  data: () => ({
    filterDisabled: false,
    offsetTop: 0,
    hadSearched: false,
    filter: false,
    rowPerPage: [10, 15, 20, 25, 50],
    search: '',
    precious: true,
    errorData: {
      error: false,
      code: 0,
      message: ''
    },
    headers: [
      {text: '车辆号牌', value: 'plate', align: 'left', placeholder: 'N/A'},
      {text: '手机号码', value: 'phone', align: 'right', placeholder: 'N/A'},
      {text: '车主姓名', value: 'name', align: 'right', sortable: false, placeholder: 'N/A'},
      {text: '用户账号', value: 'loginId', align: 'right', sortable: false, placeholder: 'N/A'},
      {text: '所在单位', value: 'orgName', align: 'right', sortable: false, placeholder: 'N/A'},
      {text: '登记类型', value: 'typeName', align: 'right', sortable: false, placeholder: 'N/A'},
      {text: '冻结状态', value: 'freezeStatus', align: 'right', sortable: false, placeholder: 'N/A',f:(v)=>(v==='true'?"已冻结":"未冻结")}
      // {text: '登记时间', value: 'createTime', align: 'right'},
      // {text: '审核状态', value: 'status', align: 'right'},
      // {text: '', value: '', align: 'right', sortable: false, width: '80px'},
    ],
    pagination: {
      page: 1,
      rowsPerPage: 10,
      descending: true,
      sortBy: 'plate'
    },
    initPage: {
      page: 1,
      rowsPerPage: 10,
      descending: true,
      sortBy: 'plate'
    },
    loading: false,
    searchFilter: {text: '按车辆号牌', value: 'plate', action: 'directions_car'},
    searchFilterItems: [
      {text: '按车辆号牌', value: 'plate', action: 'directions_car'},
      {text: '按用户账号', value: 'userId', action: 'person'}
    ],
    vehicleAmount: 0,
    vehicleList: []
  }),
  computed: {
    dark () {
      return this.$store.state.dark
    },
    searchFormatted: {
      get () {
        return this.search
      },
      set (val) {
        // console.log('set', this.search, this.searchFilter)
        if (this.searchFilter instanceof Object && this.searchFilter.value === 'plate') {
          this.search = (val + '').toUpperCase()
        }
        else {
          this.search = val
        }
      }
    }
  },
  watch: {
    search (val) {
      if (!val.trim()) {
        this.vehicleList = []
        this.vehicleAmount = 0
        this.hadSearched = false
      }
    }
  },
  methods: {
    togglePrecious () {
      this.precious = !this.precious
      if (this.precious) {
        this.searchFilter = {text: '按车辆号牌', value: 'plate', action: 'directions_car'}
        this.filterDisabled = true
      }
      else {
        this.filterDisabled = false
      }
    },
    async getVehicles () {
      if (!this.search) {
        return {items: [], amount: 0}
      }
      this.loading = true
      this.hadSearched = true
      let {items, amount} = await this.$store.dispatch('pass/searchVehicles', {
        plate: this.search
      })

      this.loading = false
      this.vehicleAmount = amount
      console.log(items)
      return {items: items, amount: amount}
    },
    goDetails (item = {}, i = 0) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        // console.log(item.plate)
        this.go({
          name: 'VehicleStatisticDetails',
          params: {
            plate: item.plate || ''
          }
        })
      }
    },
    go (path) {
      if (path) {
        this.$router.push(path)
      }
    },
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    }
  }

}
</script>

<style scoped>

</style>
